import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
// import { Autostart } from '@ionic-native/autostart/ngx';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { AuthenticationService } from './services/authentication/authentication.service';
import { StorageService } from './services/storage/storage.service';
import { GlobalVariables } from './common/global-variables';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  appPages:Array<{title:string;url:string,icon:string,condition:boolean}>;

  userInfo:any;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public router: Router,
    private authenticationService: AuthenticationService,
    // private autostart: Autostart,
    private ga: GoogleAnalytics,
    private storageService: StorageService,
    private globals: GlobalVariables
  ) {
    this.initializeApp();
    this.appPages = [
      {
        title: 'Home',
        url: '/tabs/home',
        icon: 'home',
        condition: true
      },
      {
        title: 'Services',
        url: '/tabs/services',
        icon: 'wallet',
        condition:true
      },
      {
        title: 'Batch Reports',
        url: '/tabs/batch-report',
        icon: 'paper',
        condition:true
      },
      {
        title: 'Settings',
        url: '/tabs/settings',
        icon: 'settings',
        condition:true
      }
    ];
    console.log("Taken From Init" + globals.userInfo);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // https://stackoverflow.com/questions/55274992/ionic-4-prevent-disable-device-hardware-backbutton
      this.platform.backButton.subscribeWithPriority(9999, () => {
        document.addEventListener('backbutton',  (event) => {
          event.preventDefault();
          event.stopPropagation();
          console.log('Disabled Hardware back button');
        }, false);
      });

      this.statusBar.styleDefault();

      // Initialise Google analytics
      // https://www.javascripttuts.com/introduction-to-ionic-google-analytics/
      this.ga.startTrackerWithId('UA-157946851-1').then(() => {
        // Google analytics initialised successfully
      }).catch(e => {
        console.log('Error starting GoogleAnalytics : ' + e);
      });

      this.authenticationService.authenticationState.subscribe(authState => {
        if (authState) {
          this.router.navigate(['tabs/home']);
        } else if (authState === null) {
          this.router.navigate(['device-setup']);
        } else {
          this.router.navigate(['login']);
        }
      });
      this.splashScreen.hide();
      // this.autostart.enable();
    });
  }
}
